import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'

export const mutation = (accompanimentId: number): Promise<any> => {
  return axios.delete(`orders/trackings/${accompanimentId}`)
}

export function useDeleteItemAccompaniment() {
  const queryClient = useQueryClient()

  return useMutation(mutation, {
    onSuccess: () => {
      queryClient.invalidateQueries('itemAttachments')
      toast.success('Acompanhamento  excluído com sucesso!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível excluir o acompanhamento!')
    }
  })
}
